import React from 'react';
import { PillButton, Stack, Text } from 'library/ui';

export function BannedButton({
    bannedAll,
    bannedLocations,
    setOpenBanModal,
}: {
    bannedAll: boolean;
    bannedLocations: number;
    setOpenBanModal: (open: boolean) => void;
}) {
    const phrase = bannedLocations === 1 && !bannedAll ? 'location' : 'locations';

    return (
        <Stack gap="sm">
            <PillButton variant="secondary" onClick={() => setOpenBanModal(true)}>
                Block this Worker
            </PillButton>
            <Text size="sm" tone="secondary">
                Currently blocked at {bannedAll ? 'all' : bannedLocations ?? 0} {phrase}
            </Text>
        </Stack>
    );
}
